import {FC} from "react";
import CommonAppLayout from "./Common";
import {CircleUserRound, BookmarkCheck, MessageCircle} from "lucide-react";
import {DASHBOARD_TARGET, DASHBOARD_URL, CAS_FRONTEND_URL} from "api/axios";
import useUser from "contexts/User/useUser";
import {IAccountant} from "api/types";
import accountantApi from "api/accountant";

const AccountantAppLayout: FC = () => {
  const user = useUser() as IAccountant;

  const onGoToDashboard = () => {
    if (DASHBOARD_TARGET === "cas") {
      window.location.href = CAS_FRONTEND_URL;
      return;
    }
    accountantApi.openGym(user.magic).then(({token}) => {
      const url = new URL("https://courses.akadian.com/free-exercises/roadmap-dashboard");
      url.searchParams.set("booksmatch_token", token);
      url.searchParams.set("magic", user.magic);
      window.open(url.toString(), "_self");
    });
  };

  const routes = [
    {
      name: "BooksMatch Profile",
      icon: CircleUserRound,
      path: "/profile",
      staticBack: {
        label: "Back to Dashboard",
        url: DASHBOARD_URL,
        onClick: onGoToDashboard,
      },
    },
    {
      name: "BooksMatch Messages",
      icon: MessageCircle,
      path: "/chat",
    },
    {
      name: "Contact Tracker",
      icon: BookmarkCheck,
      path: "/proposals",
    },
  ];

  return <CommonAppLayout routes={routes} />;
};

export default AccountantAppLayout;
